import Swal from "sweetalert2";

const primaryColor = '#556ee6';
const errorColor = '#f46a6a';
const defaultOkIcon = 'check';
const defaultCancelIcon = 'arrow-back';

export function swalFire(options) {
    const defaultButtonClass = 'btn btn-label btn-min-width';
    const defaultOptions = {
        title: '',
        text: '',
        html: '',
        icon: '',
        showCancelButton: false,
        confirmButtonText: getTextWithIcon(defaultOkIcon, 'Ok'),
        confirmButtonIcon: defaultOkIcon,
        confirmButtonColor: primaryColor,
        cancelButtonText: getTextWithIcon(defaultCancelIcon, 'Cancel'),
        cancelButtonIcon: defaultCancelIcon,
        cancelButtonColor: primaryColor,
        customClass: {
            confirmButton: defaultButtonClass,
            cancelButton: defaultButtonClass,
        },
    }

    let swalOptions = Object.assign(defaultOptions, options);

    if (undefined !== options.confirmButtonText) {
        swalOptions.confirmButtonText = getTextWithIcon(swalOptions.confirmButtonIcon, options.confirmButtonText);
    }
    delete swalOptions.confirmButtonIcon;

    if (undefined !== options.cancelButtonText) {
        swalOptions.cancelButtonText = getTextWithIcon(swalOptions.cancelButtonIcon, options.cancelButtonText);
    }
    delete swalOptions.cancelButtonIcon;

    return Swal.fire(swalOptions);
}

export function swalWarningFire(options) {
    const warningOptions = {
        icon: 'warning',
    }

    const swalOptions = Object.assign(warningOptions, options);

    return swalFire(swalOptions);
}

export function swalErrorFire(options) {
    const warningOptions = {
        icon: 'error',
        confirmButtonColor: errorColor,
    }

    const swalOptions = Object.assign(warningOptions, options);

    return swalFire(swalOptions);
}

export function swalRemoveFire(options) {
    const warningOptions = {
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonIcon: 'trash',
        confirmButtonColor: errorColor,
    }

    const swalOptions = Object.assign(warningOptions, options);

    return swalFire(swalOptions);
}

export function swalConfirmFire(options) {
    const confirmOptions = {
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'OK',
        confirmButtonIcon: 'like',
        confirmButtonColor: primaryColor,
        cancelButtonColor: errorColor,
    };
    const swalOptions = Object.assign(confirmOptions, options);

    return swalFire(swalOptions);
}

function getTextWithIcon(icon, text) {
    return '<i class="label-icon bx bx-' + icon + '"></i> ' + text;
}
